<template>
    <div>
        <v-layout row wrap justify-end class="pa-0 ma-0">
            <v-switch
                    class="pa-0 mr-5"
                    style="max-width:150px;"
                    label="Show Monthly"
                    v-model="showMonthly"
                    color="primary"
            ></v-switch>
        </v-layout>
        <v-layout row wrap justify-center id="pricing-list-headers">
            <v-flex xs12 md3 class="list-item-border-right">
                <v-list two-line style="padding:0 !important">
                    <div class="list-header" style="align-content: center">
                        Software Edition Comparison Chart
                        <br>
                        <v-btn color="primary" @click.native="changeLocation('try-for-free')">Try For Free</v-btn>
                    </div>
                </v-list>
            </v-flex>
            <v-flex xs12 md2 class="list-item-border-right">
                <v-list two-line style="padding:0 !important">
                    <div class="list-header" style="background-color: #2196F3">
                        Essentials <br> {{showProduct(0)}}
                        <div class="per-user--text">USD/user/per month</div>
                        <div class="per-user--text" v-if="!showMonthly">(billed annually)</div>
                    </div>
                </v-list>
            </v-flex>
            <v-flex xs12 md2 class="list-item-border-right">
                <v-list two-line style="padding:0 !important">
                    <div class="list-header" style="background-color: #8E24AA">
                        Professional <br> {{showProduct(1)}}
                        <div class="per-user--text">USD/user/per month</div>
                        <div class="per-user--text" v-if="!showMonthly">(billed annually)</div>
                    </div>
                </v-list>
            </v-flex>
            <v-flex xs12 md2 class="list-item-border-right">
                <v-list two-line style="padding:0 !important">
                    <div class="list-header" style="background-color: #00796b">
                        Business <br> {{showProduct(2)}}
                        <div class="per-user--text">USD/user/per month</div>
                        <div class="per-user--text" v-if="!showMonthly">(billed annually)</div>
                    </div>
                </v-list>
            </v-flex>
            <v-flex xs12 md2>
                <v-list two-line style="padding:0 !important">
                    <div class="list-header" style="background-color: #673ab7">
                        Enterprise <br> {{showProduct(3)}}
                        <div class="per-user--text">USD/user/per month</div>
                        <div class="per-user--text" v-if="!showMonthly">(billed annually)</div>
                    </div>
                </v-list>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center v-if="mobileLayout === false">
            <v-flex xs12 sm3 class="list-item-border-right">
                <v-list two-line style="padding-top:0px !important">
                    <template v-for="(item, index) in items">
                        <v-divider
                                v-if="item.divider"
                                :inset="item.inset"
                                :key="index"
                        ></v-divider>

                        <v-list-tile
                                v-else
                                :key="item.title"
                                avatar
                        >
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </v-list>
            </v-flex>
            <v-flex xs12 sm2 class="list-item-border-right">
                <vorsi-essentials-list></vorsi-essentials-list>
            </v-flex>
            <v-flex xs12 sm2 class="list-item-border-right">
                <vorsi-professional-list></vorsi-professional-list>
            </v-flex>
            <v-flex xs12 sm2 class="list-item-border-right">
                <vorsi-business-list></vorsi-business-list>
            </v-flex>
            <v-flex xs12 sm2>
                <vorsi-enterprise-list></vorsi-enterprise-list>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center v-if="mobileLayout === false">
            <v-btn large color="primary" @click.native="changeLocation('try-for-free')">Try For Free</v-btn>
        </v-layout>
        <v-layout row wrap justify-end v-if="mobileLayout === false">
            <v-flex xs4>
                <div class="full-circle mr-2 mt-3"></div>
                <span>Included</span>
                <div class="full-circle-secondary ml-4 mr-2 mt-3"></div>
                <span>Additional Costs Apply</span>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        created() {
            axios.get('/pricing').then(response => {
                this.pricing = response.data
            });
            setTimeout(() => {
                this.mobileLayout = !(window.innerWidth > 960);
            }, 250)
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.mobileLayout = !(window.innerWidth > 960);
                });
            });
            this.$nextTick(() => {
                window.addEventListener('scroll', () => {
                    let pricingListHeaders = document.getElementById('pricing-list-headers'),
                        top = window.pageYOffset || document.documentElement.scrollTop;
                    if (top > pricingListHeaders.offsetTop && this.scrolled === false && !this.mobileLayout) {
                        this.scrolled = true;
                        pricingListHeaders.style.position = 'sticky';
                        pricingListHeaders.style.top = 0;
                        pricingListHeaders.style.zIndex = 10;
                    }
                });
            })
        },
        beforeDestroy() {
            window.removeEventListener('resize', () => {
                this.mobileLayout = !(window.innerWidth > 960);
            });
            window.removeEventListener('scroll', () => {
            })
        },
        methods: {
            changeLocation(route) {
                window.location = route
            },
            toggleShowType() {
                this.showMonthly = !this.showMonthly
            },
            showProduct(index) {
                let type = (this.showMonthly) ? 'monthly_price' : 'annual_price';
                return (this.pricing.length > 0) ? this.pricing[index][type] : ''
            }
        },
        data() {
            return {
                drawer: false,
                mobileLayout: '',
                scrolled: false,
                pricing: [],
                showMonthly: false,
                items: [
                    {divider: true, inset: false},
                    {
                        title: '<div>Advanced CRM</div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: '<div style="padding-left: 15px"># of users:</div>',
                    },
                    {divider: true, inset: true},
                    {
                        title: '<div style="padding-left: 15px"># of clients per user:</div>',
                    },
                    {divider: true, inset: true},
                    {
                        title: '<div style="padding-left: 15px">File Storage Size per user</div>',
                    },
                    {divider: true, inset: false},
                    {
                        title: "Drag 'N' Drop Form Builder",
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Searchable Client Database',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Customizable Data Table',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Event NotificationMessages',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Client Status Automation',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Dashboard & Statistics (coming soon)',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Mobile Adaptable',
                    },
                    {divider: true, inset: false},
                    {
                        title: 'Client Ownership',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Employee Management Tree',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'User Groups',
                    },
                    {divider: true, inset: false},
                    {divider: true, inset: true},
                    {
                        title: 'Sales Order System',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Client Login',
                    },
                    {
                        title: 'Calendars & Appointments (coming soon)',
                    },
                    {divider: true, inset: true},
                    {
                        title: 'Project Management (coming soon)',
                    },
                ]
            }
        }
    }
</script>